import { createContext, useContext } from 'react';

const LangContext = createContext(null);

export function LangProvider({ value, children }) {
    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
    return useContext(LangContext);
}
